import { UserStatus, UserRole } from './types';

export const roleAsDisplayName = (role: UserRole) => {
  const roles = {
    ADVISOR: 'Advisor',
    SYSTEM_ADMIN: 'System Admin',
    SERVICE_ADMIN: 'Service Admin',
  };
  return roles[role] || role;
};

export const roleAsDescription = (role: UserRole) => {
  const descriptions = {
    ADVISOR: 'Can see and work on their clients only. Cannot add or delete users.',
    SERVICE_ADMIN: 'Can see and work on all clients. Cannot add or delete users.',
    SYSTEM_ADMIN: 'Can see and work on all clients and add or delete users.',
  };
  return descriptions[role] || '';
};

export const statusAsDisplayName = (status: UserStatus) => {
  const statuses = {
    ACTIVE: 'Active',
    DEACTIVATED: 'Deactivated',
    PENDING: 'Pending',
    ARCHIVED: 'Archived',
  };
  return statuses[status] || status;
};
